import { render, staticRenderFns } from "./AppraisalRiskDrillDown.vue?vue&type=template&id=09898106&"
import script from "./AppraisalRiskDrillDown.vue?vue&type=script&lang=ts&"
export * from "./AppraisalRiskDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports